module.exports = __webpack_public_path__ + "static/media/logout.65d8dd63.svg";